import { Color } from '@genial/design-tokens';
import { StyleSheet, View } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    borderTopWidth: 1,
    borderTopColor: Color['neutral.lightest'],
  },
});

export const Separator = () => <View style={styles.container} />;
